import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const MenuItem = styled.li`
  display: inline-block;
  list-style: none;
  text-align center;
  width: 100%;
  font-size: 13px;
  padding: 10px 0;
  text-decoration: none;
  transition: all .3s;
  cursor: pointer;
  &:hover {
    background: #ccc;
  }
  @media (min-width: ${breakpoints.tablet}) {
    font-size: 16px;
  }
`;

export default MenuItem;



// WEBPACK FOOTER //
// ./src/styled-components/MenuItem.js